module.exports = __webpack_public_path__ + "img/profile-black.16bf297b.png";